/**
 * Persists signup-time marketing opt-in and Terms + Privacy acceptance via API.
 */

import axios from 'axios'

import { API_URL, API_ENDPOINTS } from '../../../constants/api'

export interface SignupPrivacyConsentPayload {
  marketingEmailOptIn: boolean
  legalTermsAccepted: boolean
}

export async function syncSignupPrivacyConsents(
  accessToken: string,
  payload: SignupPrivacyConsentPayload,
): Promise<{ ok: true } | { ok: false }> {
  try {
    const body: Record<string, unknown> = {
      marketingEmailOptIn: payload.marketingEmailOptIn,
    }
    if (payload.legalTermsAccepted) {
      body.legalTermsAccepted = true
    }
    await axios.patch(`${API_URL}${API_ENDPOINTS.users.privacyPreferences}`, body, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return { ok: true }
  } catch {
    return { ok: false }
  }
}
